'use client';

import { useEffect } from 'react';
import { sendGTMEvent } from '@/lib/gtm-wrapper';
import { getEcommerceBodyForProduct, GTMEventType } from '@/lib/GTMEventType';
import { pushRecentProduct } from '@/lib/searchLocal';
import { Product } from '@/models/Product';

export default function ProductPageGTMReporter({ product }: { product: Product }) {
  useEffect(() => {
    pushRecentProduct({
      id: product.id,
      title: product.title,
      slug: product.titleWD,
      url: product.url,
      imageUrl: product.imageUrl || product.images?.[0]?.imageUrl || '',
      price: product.price,
      priceBeforeDiscount: product.priceBeforeDiscount,
    });
    sendGTMEvent({
      event: GTMEventType.VIEW_ITEM,
      ecommerce: getEcommerceBodyForProduct(
        product,
        product?.category?.id?.toString() || '',
        product?.category?.title || '',
      ),
    });
  }, [product]);

  return null;
}
